<script setup>
import { useSettingsStore } from "~/stores/settings";
import { useAccount } from '@composables/user/useAccount';
import { useSeoStore} from "~/stores/seo";
import { useRoute } from "vue-router"
import { useAuthStore } from '@stores/auth';

const settingsStore = useSettingsStore();
const seo = useSeoStore().seo;

const { state } = useAccount();

const authStore = useAuthStore();

const settings = settingsStore.settings;
const logoUrl = settings.general_logo;
const siteHost = ref("");
const user = computed(() => useAuthStore().user);
const sectionOpen = ref(false);
const runtimeConfig = useRuntimeConfig();
const apiUrl = runtimeConfig.public.API_URL;
const interval = ref();
const tick = ref(0);
const sites = [
  'https://risco.strike777.bet',
  'https://app.portalsbet.com',
  'https://backoffice.flamix.gg',
  'https://app.ganhonabet.com',
];

const licenceId = computed(() => {
  switch (apiUrl) {
    case 'https://app.frixbet.com':
      return 'ZXlKcGRpSTZJa3h1Y2s5RFIwVnJZVzVHT0hKNFNVTkNORGxxVTNjOVBTSXNJblpoYkhWbElqb2lSRTltTVROUmEweHJSVzE1Vkc1S1JEVTFVbGxoVVQwOUlpd2liV0ZqSWpvaVptRTNPVEUwWXpFeVkySmlOVEV4WlRBeU1qUXlOR1UyTWpCalpEbGtPVGM0TlRsaE9UVTVOV1JrTW1GbE5HVmpaVFZoTURWak9EaGtNemN3TWpZek5DSXNJblJoWnlJNklpSjk=';
    case 'https://app.rei7.net':
      return 'ZXlKcGRpSTZJaXRsWmxCbE16TlJZVkI2ZEhwcWRHTXJUSEozUzFFOVBTSXNJblpoYkhWbElqb2lWMlZQU3pCa2RtMHJaM2h0T1dGWFJsTmtNVzVXUVQwOUlpd2liV0ZqSWpvaU4yWmlPR1ZtTnpNNE9UVTNZakl5T1RJM09UWXdNREF5T0dNelpqZ3lOamxqTXpZd05UWTVaRE0xTTJSa00yRTJaREJqT0dZeU5tSXhNVEUyTXpWaFl5SXNJblJoWnlJNklpSjk=';
    case 'https://backoffice.fenixbets.io':
      return 'ZXlKcGRpSTZJbk5DUkdKSUsxSm1OWFppU21Wc2FXcEZSRk5TWkZFOVBTSXNJblpoYkhWbElqb2lMemg2VmtKRlRuZDBMMjloTDNNeVdXaGxXRFpPUVQwOUlpd2liV0ZqSWpvaVlqSTFZalJqWVdJNU1qVmpaV0V4T0RnMU1HUXpPR1F3T0dRMk5tTmtNalZrWW1Ka04yVXlNVFE1TXpFM016ZzNZemt5WVRZM1pXRTJPV05qWlRjNU9TSXNJblJoWnlJNklpSjk=';
    case 'https://app.br4bet.com':
      return 'ZXlKcGRpSTZJa0ZGYnk5c2NUaDVOV1F3U0dnMGNXTnBOSEJTZDFFOVBTSXNJblpoYkhWbElqb2lVeXRTWTJkYVJ6QnFRWE51VTNvNFpqRmlZbEYyZHowOUlpd2liV0ZqSWpvaU16aGlaalprT0RFeE9HUTROVFF6TURNelpqQmpNRGd5TW1ZMU56YzJZemxtTURjd016bGlZV0l6T1dFME56VTJZakV4TURKaU9XUTVPR1U1T0RRNU9DSXNJblJoWnlJNklpSjk=';
    case 'https://app.minesbet.com':
      return 'ZXlKcGRpSTZJbmhNUkZFM01GWkpjek5vVWtWMVowdFJiMUJrWTNjOVBTSXNJblpoYkhWbElqb2lhemhPUzFFMFJVZHdVVk4yZWxOTFFqbHNkR3BOWnowOUlpd2liV0ZqSWpvaU5HVTVObUkyTXpsa09UUTNaVFZqTnpSaFpUWmtZMkU1TVRZMk9EbG1NRGs1WW1ZNE1HUTJPRFV4TldWa1pqSmlNVFJqWmpReE1qQmhOVFF3TlRjM1ppSXNJblJoWnlJNklpSjk=';
    case 'https://app.turboaposta.com':
      return 'ZXlKcGRpSTZJbEl4TUVkbVZqWjNhVkZJWXpRMGNHaDRhR0pzYmtFOVBTSXNJblpoYkhWbElqb2lWMU54VFV4ck5XcHJObXRxV0haMk5rbFFaRzVSUVQwOUlpd2liV0ZqSWpvaU5ESTNPVE0yTmpoalkyUTBNamcwWlRjek1XTXhNemd5WW1NMk5qa3hZMlE1T1RKbE9XTTFNbU0wWWpZMlpUSTVNVGxqWXpBMU1EVmtZV1UyTnpObU1TSXNJblJoWnlJNklpSjk=';
    case 'https://app.betpremiae.io':
      return 'ZXlKcGRpSTZJazVMZVM4elJIZFhhM3BPU21OVFUzbG5lRkpvTDJjOVBTSXNJblpoYkhWbElqb2lUSEJKTVN0ek4wRjNOR05GTDI1V1VGZExWVFZ5WnowOUlpd2liV0ZqSWpvaVpUVTVNelpsWkRnd09EZ3dZbUl3Tm1KaFltRXdaVFpqTkRkbFlUY3daR1UyTjJVM1kyVXlZakExTm1WaU1tRTFZVFExTVRnM01EWXlZelUyTVdaa1lpSXNJblJoWnlJNklpSjk=';
    case 'https://app.portalsbet.com':
      return 'ZXlKcGRpSTZJbUp6UkdaMmEySXhSM0poUTJkR05EWnVURXhGZFhjOVBTSXNJblpoYkhWbElqb2ljbU5PVFZKb2FWTlZjalpvUTJkQ2FsQlRRMDl2ZHowOUlpd2liV0ZqSWpvaVltRXhObVV4TkRkbFlUWTFPVFJpT0RVNU16Z3dOV1V3TkdRd1ptTTBNekExTVRObVpHRmtaRFF4TkRReU4yVmtaakE0TW1VMk5UazJObU01WldFME1TSXNJblJoWnlJNklpSjk=';
    case 'https://app.mcgames.bet':
      return 'ZXlKcGRpSTZJbnA2ZVhKall5dFphemRuTjFaQmExRmhPR2d5V0djOVBTSXNJblpoYkhWbElqb2lSVU52YkdvMWRuQmlhbEo1TUVWalZTOTBWbmhXVVQwOUlpd2liV0ZqSWpvaVpEVTRORGhoWXpFMVlqSXpOekpsT1Rrek5EQmtOamhqWXpSbE5UUXpZbU14TW1VeU56aGlNekZrT0RSbVpUVXpOekE0TVRVNE5EQXlZakk0TW1NeFlpSXNJblJoWnlJNklpSjk';
    case 'https://app.metbet.io':
      return 'ZXlKcGRpSTZJakV6TkRCR2RqQndkRE52UjBsT2RqaEliVlJyY2xFOVBTSXNJblpoYkhWbElqb2lSRlYxYUZZMmMzUkZhamhLVTBFd1REQmtNR2t2WnowOUlpd2liV0ZqSWpvaVpEZ3pOemN3WkRjNVpqTXlNRFl5WXpFM1lqVTNabUV4WmpFeU1HWmxZek15WkRBMk1qazBaV05pT0dNd1pUYzFNVGMyTldRek16a3pZVE13T1dKbVlpSXNJblJoWnlJNklpSjk==';
    default:
      return '';
  };
});

const cometaLogo = sites.includes(runtimeConfig.public.API_URL);

const loggedInTime = computed(() => {
  if (! user.value?.last_login_at) {
    return '';
  }

  // Uso apenas como dependência
  tick.value

  const valueInSeconds = Math.floor((Date.now() - (new Date(user.value.last_login_at)).getTime()) / 1000);

  const hours = `${(Math.max(Math.floor(valueInSeconds / 3600), 0))}`.padStart(2, '0');
  const minutes = `${Math.max(Math.floor(valueInSeconds % 3600 / 60), 0)}`.padStart(2, '0');
  const seconds = `${valueInSeconds % 60}`.padStart(2, '0');

  return `${hours}h ${minutes}m ${seconds}s`;
})

const affiliateLink = computed(() => {
  switch (apiUrl) {
    case 'https://risco.strike777.bet':
      return 'https://strike777.partners';
    case 'https://app.rei7.net':
      return 'https://rei7partners.net';
    default:
      return '../affiliates';
  }
});

onMounted(() => {
  siteHost.value = window.location.host;

  interval.value = setInterval(() => {
    tick.value ^= 1
  }, 1000);
});

const CFIMAGE_URL = `${runtimeConfig.public.CLOUDFLARE_HOST_URL}`;

const getImageUrl = (data) => {
  return data.image_cf 
          ? CFIMAGE_URL + data.image_cf + '/bannerModal'
          : data.src
};

const userName = computed(() => authStore.user?.name || '');

// FIX IT: Quebrado no pre-render, quando ativo retorna apenas false independente.
const isLoggedIn = computed(() => !!authStore.user);

const verifyRa = computed(() => {
  const runtimeConfig = useRuntimeConfig();
  const apiUrl = runtimeConfig.public.API_URL;
  
  switch (apiUrl) {
    case 'https://app.br4bet.com':
      return 'https://www.reclameaqui.com.br/empresa/br4bet/';
    case 'https://app.goldebet.com':
      return 'https://www.reclameaqui.com.br/empresa/gol-de-bet/';
    case 'https://backoffice.lotogreen.com':
      return 'https://www.reclameaqui.com.br/empresa/lotogreen/';
    default:
      return '/';
  }
});

</script>
<template>
  <footer class="w-full select-none">

    <client-only>
      <div class="flex flex-col xl:flex-row justify-end xl:items-center py-2 xl:py-0 px-5 xl:px-10 border-b border-brand-primary transition-all" :class="isLoggedIn || userName || loggedInTime ? 'xl:h-12' : 'h-0'">
        <p class="mr-auto" v-if="isLoggedIn">Olá, <b>{{ userName }}</b></p> 
        <div class="flex flex-col xl:flex-row xl:items-center gap-1 xl:gap-4 text-sm text-gray-400">
          <div v-if="loggedInTime" class="whitespace-nowrap">
            Tempo logado: <b>{{ loggedInTime }}</b>
          </div>
          <p class="hidden xl:flex" v-if="loggedInTime">|</p>
          <lastLoginFooter />
        </div>
      </div>
    </client-only>

    <div class="flex flex-col xl:flex-row xl:gap-16 xl:py-6 py-6 px-5 xl:px-10">
      <!-- Logo e Redes Sociais -->
      <div class="flex flex-col items-center xl:items-start xl:w-72 pt-10 xl:pt-0 xl:mb-0 order-2 xl:order-1">
        <img class="w-44 mb-4" :src="logoUrl" alt="" />
        <div class="flex w-full pt-2 items-center justify-center xl:justify-start xl:items-start whitespace-nowrap gap-3 text-white">
          <!-- Primeira linha de redes sociais -->
          <div class="flex gap-2">
            <nuxt-link
              :to="settings.general_social_telegram"
              target="_blank"
              class="flex items-center rounded-md bg-brand-background p-2 transition-all hover:bg-brand-primary/30 cursor-pointer"
            >
              <Icon name="uil:telegram" />
            </nuxt-link>

            <nuxt-link
              :to="settings.general_social_youtube"
              target="_blank"
              class="flex items-center rounded-md bg-brand-background p-2 transition-all hover:bg-brand-primary/30 cursor-pointer"
            >
              <Icon name="uil:youtube" />
            </nuxt-link>

            <nuxt-link
              :to="settings.general_social_instagram"
              target="_blank"
              class="flex items-center rounded-md bg-brand-background p-2 transition-all hover:bg-brand-primary/30 cursor-pointer"
            >
              <Icon name="uil:instagram" />
            </nuxt-link>

            <nuxt-link
              :to="settings.general_social_facebook"
              target="_blank"
              class="flex items-center rounded-md bg-brand-background p-2 transition-all hover:bg-brand-primary/30 cursor-pointer"
            >
              <Icon name="uil:facebook" />
            </nuxt-link>
          </div>
          
          <!-- Segunda linha de redes sociais -->
          <div class="flex gap-2">
            <nuxt-link
              :to="settings.general_social_twitter"
              target="_blank"
              class="flex items-center rounded-md bg-brand-background p-2 transition-all hover:bg-brand-primary/30 cursor-pointer"
            >
              <Icon name="uil:twitter" />
            </nuxt-link>

            <nuxt-link
              :to="settings.general_social_tiktok"
              target="_blank"
              class="flex items-center rounded-md bg-brand-background p-2 transition-all hover:bg-brand-primary/30 cursor-pointer"
            >
              <Icon name="ic:baseline-tiktok" />
            </nuxt-link>
          </div>
        </div>
      </div>

      <!-- Separador mobile -->
      <hr class="border-brand-background xl:hidden my-3 hidden xl:order-2">

      <!-- Grid de Links -->
      <div class="flex-1 grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 gap-8 xl:gap-12 text-gray-200 order-1 xl:order-3">
        <!-- Apostas -->
        <div class="space-y-3">
          <h2 class="text-base font-semibold text-white">Apostas</h2>
          <ul class="text-sm space-y-1">
            <li class="hover:text-brand-primary">
              <NuxtLink to="/sports">
                Apostas Esportivas
              </NuxtLink> 
            </li>
            <li class="hover:text-brand-primary">
              <NuxtLink to="/sports">
                Esportes ao Vivo
              </NuxtLink> 
            </li>
            <li class="hover:text-brand-primary">
              <NuxtLink to="/casino/slots">
                Jogos Slots
              </NuxtLink> 
            </li>
            <li class="hover:text-brand-primary">
              <NuxtLink to="/casino/live">
                Jogos ao Vivo
              </NuxtLink> 
            </li>
          </ul>
        </div>

        <!-- Comunidade -->
        <div class="space-y-3">
          <h2 class="text-base font-semibold text-white">Comunidade</h2>
          <ul class="text-sm space-y-1">
            <li class="hover:text-brand-primary">
              <NuxtLink to="/promotions">
                Promoções
              </NuxtLink> 
            </li>
            <li class="hover:text-brand-primary">
              <NuxtLink to="/">
                Blog
              </NuxtLink> 
            </li>
            <li class="hover:text-brand-primary">
              <NuxtLink to="/suport">
                Central de Ajuda
              </NuxtLink> 
            </li>
            <li class="hover:text-brand-primary">
              <NuxtLink to="/suport">
                Canais de Atendimento
              </NuxtLink> 
            </li>
            <li class="hover:text-brand-primary hidden">
              <NuxtLink to="/">
                Aplicativo móvel
              </NuxtLink> 
            </li>
            <li class="hover:text-brand-primary">
              <NuxtLink :to="settings.general_social_telegram" target="_blank">
                Acesse Nosso Telegram
              </NuxtLink> 
            </li>
          </ul>
        </div>

        <!-- Regras -->
        <div class="space-y-3">
          <h2 class="text-base font-semibold text-white">Regras</h2>
          <ul class="text-sm space-y-1">
            <li class="hover:text-brand-primary">
              <NuxtLink to="/betting-terms">
                Termos de Apostas
              </NuxtLink>
            </li>
            <li class="hover:text-brand-primary">
              <NuxtLink to="/terms-and-conditions">
                Termos e Condições
              </NuxtLink>
            </li>
            <li class="hover:text-brand-primary">
              <NuxtLink to="/privacy-policy">
                Política de Privacidade
              </NuxtLink>
            </li>
            <li class="hover:text-brand-primary">
              <NuxtLink to="/cookies-policy">
               Política de Cookies
              </NuxtLink>
            </li>
            <li class="hover:text-brand-primary">
              <NuxtLink to="/pld-ft-policy">
                Política PLD-FTP
              </NuxtLink>
            </li>
            <li class="hover:text-brand-primary">
              <NuxtLink to="/funds-and-transactions-policy">
                Política de Fundos e Transações
              </NuxtLink>
            </li>
            <li class="hover:text-brand-primary">
              <NuxtLink to="/responsible-gaming">
                Jogo responsável
              </NuxtLink>
            </li>
          </ul>
        </div>

        <!-- Links Úteis e Pagamento -->
        <div class="space-y-4">
          <div>
            <h2 class="text-base font-semibold text-white">Links Úteis</h2>
            <NuxtLink to="/suport">
              <div class="flex items-center justify-center gap-2 w-fit py-2 px-4 bg-brand-background mt-3 rounded-md hover:bg-brand-primary/30 transition-all duration-300">
                <Icon class="text-brand-primary" name="material-symbols:android-messages"/>
                <p class="text-xs xs:text-sm whitespace-nowrap">Contate-nos</p>
              </div>
            </NuxtLink>
          </div>
          
          <div class="space-y-3">
            <h2 class="text-base font-semibold text-white">Pagamento</h2>
            <div>
              <img src="/pix.png" class="w-20" alt="pix" />
            </div>
          </div>
        </div>
      </div>
    </div>
     
    <!-- Stamps -->
      <FooterStamps/>
    <!-- /Stamps -->

    <div>
      <hr v-if="useRoute().name === 'index'" v-show="seo?.html" class="border-brand-background mx-10 xl:mx-44 my-4">

      <!-- SEO -->
      <div v-if="useRoute().name === 'index'" v-show="seo?.html">

          <div class="flex flex-col w-full mt-2">

            <div class="relative">

              <article class="flex flex-col gap-px text-[10px] text-center w-full pb-4 overflow-hidden transition-all xl:pr-0"
                :class="{
                  'h-16' : !sectionOpen,
                }"
                v-html="seo?.html"
              >
              </article>

              <div class="w-full transition-all absolute bottom-0 left-0  from-transparent to-brand-background" :class="sectionOpen ? 'h-0' : 'h-10' "></div>

            </div>

            <button class="text-xs text-white/80" @click="sectionOpen = !sectionOpen">
                <p v-if="sectionOpen">
                  Ver menos
                </p>
                <p v-else>
                  Ver mais
                </p>
            </button>

          </div>
        </div>
        <!-- /SEO -->
      <hr class="border-brand-background mx-10 xl:mx-44 my-4">
    </div>


      <div class="flex flex-col items-center gap-6 md:flex-row-reverse my-7 mx-5">

          <a class="w-full flex justify-center">
            <img class="xs:w-64 sm:min-w-72"
              src="public/autorizado.png" />
          </a>

          <p class="text-justify text-xs font-medium text-gray-500">
          <b>{{ siteHost }}</b> é um site de entretenimento online que oferece aos seus
          usuários uma experiência única em apostas esportivas e jogos online.
          Esse site é operado pela <b>Sabiá Administração LTDA</b>, uma empresa registrada no Brasil,
          sob número de CNPJ <b>04.426.418/0001-16</b>, com sede em Rua Padre Joao Porto, 1293 - Apartamento 03
          - CEP 35640-000 - Volta do Brejo - Pompéu/MG, entidade devidamente autorizada a operar a modalidade
          lotérica de apostas de quota fixa no Brasil, em temática desportiva e jogos online, conjuntamente,
          pela Secretaria de Prêmios e Apostas do Ministério da Fazenda, conforme Portaria
          SPA/MF nº 399/2025, publicada em 24 de fevereiro de 2025 no Diário Oficial da República Federativa do Brasil.
          <br><br>
          Ao acessar, continuar a usar ou navegar neste site, você concorda que podemos usar determinados cookies do navegador para melhorar sua experiência ao usar nosso site. Utilizamos cookies apenas para melhorar a sua experiência e isso não interfere na sua privacidade.
        </p>
      </div>

      <hr class="border-brand-background mx-10 xl:mx-44 my-4">

      <!-- stamps -->
      <div class="flex flex-wrap justify-center items-center gap-6 px-4 sm:px-6 lg:px-10 py-6">
        <!-- Reclame Aqui -->
        <nuxt-link :to="verifyRa" target="_blank" class="flex items-center justify-center">
          <img src="/verifyRA.svg" alt="Selo Reclame Aqui" class="h-10 max-w-full hover:opacity-75 transition duration-200" />
        </nuxt-link>

        <!-- BeGambleAware e Gambling Therapy -->
        <div class="flex items-center gap-4">
          <nuxt-link to="https://www.gambleaware.org/" target="_blank" class="flex items-center justify-center">
            <img src="/BeGambleAware.svg" alt="BeGambleAware" class="h-10 max-w-full hover:opacity-75 transition duration-200" />
          </nuxt-link>
          <nuxt-link to="https://www.gamblingtherapy.org/pt-br/" target="_blank" class="flex items-center justify-center">
            <img src="/gt_logo.webp" alt="Gambling Therapy" class="h-10 max-w-[4rem] hover:opacity-75 transition duration-200" />
          </nuxt-link>
        </div>

        <!-- 18+ e IBIA -->
        <div class="flex items-center gap-4">
          <nuxt-link to="/responsible" class="flex items-center gap-2 font-bold hover:opacity-75 transition duration-200">
            <span
              class="flex h-14 w-14 items-center justify-center rounded-full border-4 border-brand-primary bg-black text-white text-xs sm:text-sm"
              >18+</span>
            <span class="text-[12px] sm:text-sm uppercase max-w-[8rem] sm:max-w-none text-white">Jogue com responsabilidade</span>
          </nuxt-link>
          <nuxt-link to="https://ibia.bet/who-we-are/" target="_blank" class="flex items-center justify-center">
            <img src="/IBIA-WHITE.svg" alt="IBIA" class="h-10 max-w-[6rem] hover:opacity-75 transition duration-200" />
          </nuxt-link>
        </div>

        <!-- RA widget condicional -->
        <div id="ra-verified-seal" v-if="apiUrl === 'https://risco.strike777.bet'"></div>
      </div>

      <div class="text-white text-center my-5 mb-20 xl:mb-10">
        <div class="flex justify-center items-center gap-2 text-sm text-brand-primary font-semibold">
          <NuxtLink 
            href="https://sabiaadministracao.omd.app.br/sabiaadministracao/externo/index.html" 
            class="hover:underline" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            Ouvidoria
          </NuxtLink>
          <span class="text-white">|</span>
          <NuxtLink 
            href="https://sabiaadministracao.omd.app.br/sabiaadministracao/externo/index.html" 
            class="hover:underline" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            Denúncias
          </NuxtLink>
          <span class="text-white">|</span>
          <NuxtLink 
            href="/privacy" 
            class="hover:underline"
          >
            Privacidade
          </NuxtLink>
          <span class="text-white hidden">|</span>
          <span class="text-white hidden">Suporte:</span>
          <a href="mailto:suporte@br4.bet.br" class="hover:underline hidden">suporte@br4.bet.br</a>
        </div>
      </div>

  </footer>
</template>
<style>
#ra-widget-verified .ra-widget-verified-wrapper {
  background: none !important;
}

#ra-widget-verified .ra-widget-verified-wrapper .ra-widget-verified-content{
  border: none !important;
}
</style>
